<footer class="footer">
    <div class="container">
    <div class="content has-text-centered background">
      <p class="text">
          some footer text 2019
      </p>
    </div>
    </div>
</footer>